import React from "react";

import { IconBell } from "~/components/icon";

import { BREADCRUMB_ICON_CLASS } from "../../../components/react/icon/Icon";
import { useNavigateToLink } from "../../../components/react/link";
import { NOTIFICATIONS_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const NotificationsIndexBreadcrumb: React.FC = () => {
	const link = useNavigateToLink(NOTIFICATIONS_PATH, {
		params: {},
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return <BreadcrumbLayout icon={<IconBell className={BREADCRUMB_ICON_CLASS} />} label="Notifications" to={link} />;
};
